import moment from 'moment';
import ExportJsonExcel from 'js-export-excel';

class TenCorrectsExcel {
    exportExcel(data) {
        let option = {};  // La opción representa el archivo de Excel
        let tenCorrectsData = this.revisarIndicador10Correctos(data.admisiones, data.resumen, data.correctos_entrevistados, data.porcentaje_correctos);
        option.fileName = 'Indicador 10 Correctos';  // Nombre del archivo Excel
        option.datas = [
            {
                sheetData: tenCorrectsData.data,  // Fuente de datos en archivo Excel
                sheetName: 'Indicador 10 Correctos',  // nombre de la página de hoja en el archivo de Excel
            }
        ]
        let toExcel = new ExportJsonExcel(option);  // Generar archivo de Excel
        toExcel.saveExcel();  // Descargar archivo de Excel
    }

    revisarIndicador10Correctos(dataPatients, dataResumen, correctos_entrevistados, porcentaje_correctos) {
        let dataTable = [];
        let casillasVacias = this.generarCasillasVacias();

        //Titulos
        let CasillasTitulos = this.generarTitulos();
        dataTable.push(CasillasTitulos);

        let classifiedServices = dataPatients.reduce((acc, curr) => {
            const nameKey = curr.servicio.servicios[0].codigo ?? curr.servicio.servicios[0].cupscod;
            const key = curr["codigo_cups_proc"];
            const curGroup = acc[key] ?? [];
            return { ...acc, [key]: [...curGroup, curr] };
        }, {})

        console.log("classifiedServices", classifiedServices)

        Object.values(classifiedServices).forEach(service => {
            let cantService = service.length;
            let correctoCompleted = service.reduce((acc, curr) => {
                if (!!curr.correctos) {
                    if (curr.correctos.correctos.paciente === "SI") acc += 1
                }
                return acc
            }, 0)
            let promCorrectos = (correctoCompleted / cantService) * 100;

            console.log(cantService, correctoCompleted, promCorrectos)
            //Admisiones
            let casillaEstadistica = this.generarCasillaEstadistica(cantService, correctoCompleted, promCorrectos);
            for (let i = 0; i < service.length; i++) {
                let infoDetallada = this.generarInformacionDetallada(service[i]);
                dataTable.push(infoDetallada);
            }
            dataTable.push(casillaEstadistica);
            dataTable.push(casillasVacias);
        })


        dataTable.push(casillasVacias);

        let casillaEstadistica = this.generarCasillaEstadistica(dataPatients.length, correctos_entrevistados, porcentaje_correctos);

        dataTable.push(casillaEstadistica);
        dataTable.push(casillasVacias);

        let paciente_correcto = this.generarCasillaResumen(dataResumen.paciente_correcto, "PACIENTE CORRECTO");
        let procedimiento_correcto = this.generarCasillaResumen(dataResumen.procedimiento_correcto, 'PROCEDIMIENTO CORRECTO SOLICITADO');
        let cumple_requisitos = this.generarCasillaResumen(dataResumen.cumple_requisitos, 'Cumple con los requerimientos del examen');
        let suspension_medicamento = this.generarCasillaResumen(dataResumen.suspension_medicamento, "Suspension Medicamento");
        let otras_condiciones = this.generarCasillaResumen(dataResumen.otras_condiciones, "Otros");
        let requiere_medicamento = this.generarCasillaResumen(dataResumen.requiere_medicamento, "REQUIERE ALGUN MEDICAMENTO PARA EL EXAMEN");
        let medicamento_correcto = this.generarCasillaResumen(dataResumen.medicamento_correcto, "MEDICAMENTO CORRECTO");
        let administracion_correcta = this.generarCasillaResumen(dataResumen.administracion_correcta, "VIA DE ADMINISTRACIÓN CORRECTA");
        let dosis_correcta = this.generarCasillaResumen(dataResumen.dosis_correcta, "DOSIS");
        let momento_correcto = this.generarCasillaResumen(dataResumen.momento_correcto, "MOMENTO U HORARIO CORRECTO");
        let necesidad_medicamento = this.generarCasillaResumen(dataResumen.necesidad_medicamento, "INFORMAR AL PACIENTE LA NECESIDAD DEL USO DEL MEDICAMENTO");
        let informado_efectos_secundarios = this.generarCasillaResumen(dataResumen.informado_efectos_secundarios, "SE INFORMARON POSIBLES EFECTOS SECUNDARIOS");

        dataTable.push(paciente_correcto);
        dataTable.push(procedimiento_correcto);
        dataTable.push(cumple_requisitos);
        dataTable.push(suspension_medicamento);
        dataTable.push(otras_condiciones);
        dataTable.push(requiere_medicamento);
        dataTable.push(medicamento_correcto);
        dataTable.push(administracion_correcta);
        dataTable.push(dosis_correcta);
        dataTable.push(momento_correcto);
        dataTable.push(necesidad_medicamento);
        dataTable.push(informado_efectos_secundarios);

        let sheet =
        {
            data: dataTable
        }

        return sheet;
    }

    generarTitulos() {
        let casillas = {
            '1': "NÚMERO DE ADMISIÓN",
            '2': "FECHA INGRESO",
            '3': "HORA INGRESO",
            '4': "DOCUMENTO",
            '5': "NOMBRE",
            '6': "ACTIVIDAD",
            '7': "FECHA DE REGISTRO",
            '8': "HORA DE REGISTRO",
            '9': "USUARIO"
        }
        return casillas;
    }

    generarInformacionDetallada(data) {
        let casillas = {
            '1': data.id_admision != null && data.id_admision != undefined ? data.id_admision : "",
            '2': data.fecha_admision != null && data.fecha_admision != undefined ? moment(data.fecha_admision).format("DD/MM/YYYY") : "",
            '3': data.fecha_admision != null && data.fecha_admision != undefined && data.fecha_admision != "" ? moment(data.fecha_admision).format("h:mm:ss a") : "",
            '4': data.documento_paciente != null && data.documento_paciente != undefined ? data.documento_paciente : "",
            '5': data.nombre_paciente != null && data.nombre_paciente != undefined ? data.nombre_paciente : "",
            '6': data.servicio_realizado != null && data.servicio_realizado != undefined ? data.servicio_realizado : "",
            '7': data.fecha_correctos != null && data.fecha_correctos != undefined ? moment(data.fecha_correctos).format("DD/MM/YYYY") : "",
            '8': data.fecha_correctos != null && data.fecha_correctos != undefined ? moment(data.fecha_correctos).format("h:mm:ss a") : "",
            '9': data.nombre_usuario_correctos != null && data.nombre_usuario_correctos != undefined ? data.nombre_usuario_correctos : "",
        }
        return casillas;
    }

    generarCasillasVacias() {
        let casillas = {
            '1': "",
            '2': "",
            '3': "",
            '4': "",
            '5': "",
            '6': "",
            '7': "",
            '8': "",
            '9': "",
        }
        return casillas;
    }

    generarCasillaEstadistica(total, total10Correctos, indice) {
        let casillas = {
            '1': "Total Registros",
            '2': total,
            '3': "Total 10 Correctos",
            '4': total10Correctos,
            '5': "",
            '6': "Indice",
            '7': `${indice.toFixed(3)} %`
        }
        return casillas;
    }

    generarCasillaResumen(data, title) {
        let casillas = {
            '1': "",
            '2': "",
            '3': "",
            '4': "",
            '5': "",
            '6': "",
            '7': "",
            '8': "",
            '9': title.toUpperCase(),
            '10': data
        }
        return casillas;
    }

}

export default new TenCorrectsExcel();